import CloseIcon from "assets/images/CloseIcon";
import {
  common as stringsCommon,
  confirmDeleteInsuranceCard as strings,
} from "strings";

import Button from "components/Button";
import PageTitle from "components/PageTitle";
import StyledModal from "components/StyledModal";

import styles from "./ConfirmDeleteInsuranceCard.module.css";

export default function ConfirmDeleteInsuranceCard(props: {
  visible: boolean;
  onClose: () => void;
  onDelete: () => void;
  loading: boolean;
}) {
  return (
    <StyledModal visible={props.visible} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.detailsContainer}>
          <div className={styles.section}>
            <PageTitle className={styles.header}>{strings.header}</PageTitle>
          </div>
          <button
            className={styles.close}
            onClick={() => {
              return props.onClose();
            }}
          >
            <CloseIcon />
          </button>
        </div>
        <Button loading={props.loading} onClick={props.onDelete}>
          {strings.yes}
        </Button>
        <Button
          className={styles.cancel}
          variant="minimal"
          onClick={props.onClose}
          disabled={props.loading}
        >
          {stringsCommon.cancel}
        </Button>
      </div>
    </StyledModal>
  );
}
